module.exports = __webpack_public_path__ + "static/preamps_1600.3f412fb2.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/preamps_1600.jpg
// module id = 663
// module chunks = 0